import { useEffect } from 'react';
import { trackPageView } from '@tasama/utils';

/**
 * Tracks the initial /onboarding entry as a GA4 page_view.
 *
 * Step-level tracking (company-type → your-details → ...) is handled inside
 * useOnboardingNavigation, which owns the internalStep state. There are no
 * real route changes in the onboarding wizard, so router.subscribe is not used.
 */
export function usePageTracking(): void {
  useEffect(() => {
    trackPageView(window.location.pathname + window.location.search);
  }, []);
}
